<template>
  <ion-page class="sign">
    <common-background
      :has-mode-switch="hasModeSwitch"
      :title="pageTitle"
      router-type="modal"
      @router-back="onConfirmCloseWrap"
    >
      <template #default>
        <div class="sign_page">
          <VideoHeight />
          <div class="word-list">
            <ion-item-sliding
              v-for="(item, index) in dataList"
              :ref="'sliding' + [index]"
              :key="index"
              class="word-list_item flex-row cursor-pointer itemStyle"
              :class="{ 'item-checked': item.checked }"
              :disabled="!canSliding"
              @ionDrag="onDrag"
              @touchstart="handleStyle(true, index)"
              @touchend="handleStyle(false, index)"
              @mousedown="handleStyle(true, index)"
              @mouseup="handleStyle(false, index)"
            >
              <div v-if="wordSequence[currentWordIndex] === index" class="left-line"></div>

              <ion-item
                class="ion-item signItem flex-row justify-between align-center itemControl signItem"
                @click="onShowParaphrase(index, item, true)"
              >
                <div class="w100 flex-row justify-between align-center flex-wrap">
                  <div class="word-content flex-row align-center">
                    <span
                      class="word-style switch-font-size-video flex-row align-center mr-3"
                      :class="{
                        'display-none': isManual
                          ? item.showParaphrase == 3
                          : item.showParaphrase == 4,
                      }"
                    >
                      {{ item.word }}
                    </span>
                    <span
                      class="cnword word-style gray-color"
                      :class="{
                        'display-none': isManual
                          ? item.showParaphrase != 2
                          : item.showParaphrase != 3,
                      }"
                    >
                      {{ item.paraphrase }}
                    </span>
                  </div>
                  <div
                    v-if="(!item.autoIndex && item.checked) || autoShowClickButton(index, item)"
                    class="word-style auto-button"
                  >
                    <img
                      v-if="!item.autoIndex && item.checked"
                      :src="getBrandImageUrl('speed/two_one.png')"
                      style="width: 8vw; transform: scale(1.3)"
                      alt=""
                      @click.stop="
                        playUniversalFormulaAudioWrap(
                          item.word,
                          item.paraphrase,
                          50 * speedRate,
                          index
                        )
                      "
                    />
                    <div
                      v-if="autoShowClickButton(index, item)"
                      :class="[
                        'auto-index',
                        isDisabled ? 'auto-index__disabled' : `auto-index-${item.autoIndex}`,
                      ]"
                      :style="{
                        '--progress': isNaN(progress) ? '0%' : `${progress}%`,
                        '--last': isNaN(progress) ? '100%' : `${100 - progress}%`,
                      }"
                      :data-progress="item.autoIndex"
                      @click.stop="debouncePlayAudio(index, item)"
                    ></div>
                  </div>
                </div>
              </ion-item>
              <ion-item-options class="optionsList">
                <ion-item-option
                  class="sign-option"
                  @click="openErrorSubmitDialog(item, index, $event)"
                >
                  <img :src="getBrandImageUrl('speed/sign_error.png')" alt="" />
                </ion-item-option>
                <ion-item-option
                  type="reset"
                  class="sign-option"
                  @click="markDifficult(item.vocabularyId, index, $event)"
                >
                  <img :src="getBrandImageUrl('speed/sign_collect.png')" alt="" />
                </ion-item-option>
                <ion-item-option
                  type="reset"
                  class="sign-option"
                  @click="onParaphrase(item.word, index, $event)"
                >
                  <img :src="getBrandImageUrl('speed/sign_detail.png')" alt="" />
                </ion-item-option>
                <ion-item-option
                  type="reset"
                  class="sign-option"
                  @click="routerToAiVocabulary(item.word)"
                >
                  <img :src="getBrandImageUrl('speed/sign_dictionary.png')" alt="" />
                </ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </div>
        </div>
      </template>
      <template #rightTitle>
        <switch-font-size />
        <img
          :title="!isManual ? '人工' : 'ai带读'"
          class="mode-switch mr-3"
          :class="{ 'button-disabled': !hasModeSwitch }"
          :src="exerciseModalTxt"
          alt=""
          @click="changeExerciseModal"
        />
        <speed-switch v-if="!isManual" ref="speedSwitch" />
      </template>
    </common-background>
    <div class="sign_bottom">
      <div class="sign_bottom-content flex-row justify-between align-center">
        <span
          ><span class="common-color">{{ currentStep }}</span
          >/{{ totalPage }}</span
        >
        <div>
          <!--<ion-button shape="round" class="light_green_bg" @click="changeExerciseModal">
            <img :src="exerciseModalTxt" alt="" />
            {{ exerciseModalTxt }}
          </ion-button>-->
          <img
            v-if="clickedAll"
            title="快闪魔方"
            class="button-icon"
            src="@/assets/teacher_index/version5/cut_box.svg"
            alt=""
            @click="openCutBox"
          />
          <!--<ion-button v-if="clickedAll" class="light_green_bg" shape="round" @click="openCutBox">
            <img class="button" :src="getBrandImageUrl('speed/scissors_button.png')" alt="" />
          </ion-button>-->
          <img
            title="打乱"
            class="button-icon"
            src="@/assets/teacher_index/version5/random_play.svg"
            alt=""
            @click="throttledRandom"
          />
          <!--<ion-button class="light_green_bg ml-2" shape="round" @click="throttledRandom">
            <img class="button" :src="getBrandImageUrl('speed/random_button.png')" alt="" />
          </ion-button>-->
          <img
            v-if="isManual"
            title="标准读音"
            class="button-icon"
            src="@/assets/teacher_index/version5/standard_sound.svg"
            alt=""
            @click="onSpeak"
          />
          <!--<ion-button
            class="light_green_bg ml-2"
            shape="round"
            :disabled="!isManual"
            @click="onSpeak"
          >
            <img class="button" :src="getBrandImageUrl('speed/play_button.png')" alt="" />
          </ion-button>-->
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import {
  IonItem,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
  IonPage,
  modalController,
} from "@ionic/vue"

import myAjax from "axios"
import {
  cut,
  documentTextSharp,
  flagSharp,
  playSkipBack,
  playSkipForward,
  shuffle,
  volumeHigh,
} from "ionicons/icons"
import Paraphrase from "./Paraphrase"
import CommonBackground from "@/components/CommonBackground.vue"
import { playUniversalFormulaAudio } from "@/js/commonMethod"
import AIGenerate from "@/views/AIGenerate/AIGenerate.vue"
import switchModeDialog from "@/views/speedVideo/switchModeDialog.vue"
import PageDialog from "@/components/PageDialog.vue"
import { useStorage, useThrottleFn } from "@vueuse/core"
import SpeedSwitch from "@/components/speedSwitch.vue"
import getOssPlayInstance from "@/js/ossPlay"
import ErrorSubmitDialog from "@/components/ErrorSubmitDialog.vue"
import { getBrandImageUrl } from "@/js/brandImages"
import aiClassing from "@/assets/teacher_index/version5/ai_classing.svg"
import handleClick from "@/assets/teacher_index/version5/handle_click.svg"
import { throttle } from "lodash"
import disabledAi from "@/assets/teacher_index/version5/disabled_ai.svg"
import disabledArtificial from "@/assets/teacher_index/version5/disabled_artificial.svg"
import mqttServer from "@/js/mqtt"
import pagesQueue from "@/js/pagesQueue"
import { ref } from "vue"
import VideoHeight from "@/views/liveVideo/components/videoHeight.vue"
import SwitchFontSize from "@/views/liveVideo/components/switchFontSize.vue"

const speedRate = useStorage("xf-speed", 1, localStorage)
const speedSwitch = ref(null)

// 常量定义
const CONSTANTS = {
  // 流程步骤
  REVIEW_STEP: 24,
  LISTEN_STEP: 33,
  // 音频相关
  DEFAULT_SPEED: 60,
  AUTO_SPEED: 70,
  MAX_SPEED: 100,
  DEFAULT_AUDIO_TYPE: "DNO01",
  // 自动发音步骤
  MAX_AUTO_INDEX: 5,
  // 延迟时间
  TOUCH_MOVE_DELAY: 500,
  SLIDING_CLICK_DELAY: 500,
  PAGE_FLAG_DELAY: 600,
  MODAL_DISMISS_DELAY: 2000,
  OBSERVER_DELAY: 1000,
  // 状态数量
  MANUAL_STATUS_NUM: 3,
  AI_STATUS_NUM: 4,
  // 速度列表
  SPEED_LIST: [1, 1.2, 1.5, 2],
  // Transform值
  SLIDING_TRANSFORM: -232,
}

export default {
  name: "SpeedSign",
  components: {
    SpeedSwitch,
    CommonBackground,
    IonPage,
    IonItem,
    IonItemSliding,
    IonItemOption,
    IonItemOptions,
    VideoHeight,
    SwitchFontSize,
  },
  props: ["studentId", "step"],
  setup() {
    return {
      moveTimer: null,
      playSkipBack,
      playSkipForward,
      cut,
      shuffle,
      volumeHigh,
      flagSharp,
      documentTextSharp,
      speedRate,
      speedSwitch,
    }
  },

  data() {
    return {
      currentEvent: null,
      pageTitle: "单词识记",
      isDisabled: false,
      dataList: [],
      totalPage: undefined, //总页数

      //___________________________________

      wordSequence: [], //练习流程
      isDownward: true, //自动发音方向
      speakIndex: 0, //当前发音数组下标
      currentStep: this.step || 1, // 当前组的下标
      currentWordIndex: 1, // 当前所学单词在整个练习流程中的数组下标
      autoButtonIndex: 0, //显示自动点击按钮,决定当前显示哪一个按钮
      currentItem: {}, // 当前框选的行数据
      isManual: sessionStorage.getItem("isManual")
        ? JSON.parse(sessionStorage.getItem("isManual"))
        : false,
      exerciseModalTxt: handleClick,
      throttledRandom: useThrottleFn(this.doRandom, CONSTANTS.MODAL_DISMISS_DELAY),
      autoAudio: getOssPlayInstance(),
      progress: 0,
      currentSpeakItem: {},
      currentSpeakIndex: undefined,
      isAutoSpeechPlaying: false,
      hasModeSwitch: true,
      slidingItemClicked: false,
      timer: null,
      disabledAi: disabledAi,
      disabledArtificial: disabledArtificial,
      debouncePlayAudio: throttle(
        (index, item) => this.debouncePlayAudioWrap(index, item),
        CONSTANTS.MODAL_DISMISS_DELAY,
        {
          leading: true,
          trailing: false,
        }
      ),
      styleFlag: false,
      instructData: {
        project: "lxll",
        page: "teachIndex",
        module: "Sign",
        pageModle: true,

        userType: 1,
        data: null,
        fn: "",
        param: null,
        timestamp: " ",
      },
      cutBoxModal: null,
      firstClickSpeak: true,
      // 移动
      moveTransform: 0,
      canSliding: null,
      permissionChangeCallback: null, // 权限变化回调函数
    }
  },
  computed: {
    clickedAll() {
      return this.dataList.every((item) => item.clicked)
    },
    progressStyle() {
      const progress = isNaN(this.progress) ? 0 : this.progress
      return {
        "--progress": `${progress}%`,
        "--last": `${100 - progress}%`,
      }
    },
  },
  watch: {
    progress(newVal) {
      if (newVal === 100) {
        // 仅当为自动领读播放时，才推进 autoIndex，避免标准读音完成影响进度
        if (this.isAutoSpeechPlaying && this.currentSpeakIndex !== undefined) {
          const currentItem = this.dataList[this.currentSpeakIndex]
          if (currentItem.autoIndex < CONSTANTS.MAX_AUTO_INDEX) {
            currentItem.autoIndex++
          } else {
            currentItem.autoIndex = undefined // 废弃发音步骤
            currentItem.autoStudyNewWord = false // 把这个单词标记为已学过

            // 找到蓝光指引的单词下标
            const next = this.getCurrentClueIndex()
            // 如果蓝光指引的单词就是下一个单词，则直接展示
            this.autoButtonIndex = next
          }
        }
        // 重置标记
        this.isAutoSpeechPlaying = false
      }
    },
    // 监听autoAudio?.loading,如果正在加载，返回true，否则返回false
    "autoAudio.loading"(val) {
      this.isDisabled = val
    },
    hasModeSwitch(val) {
      if (!val) {
        this.exerciseModalTxt = this.isManual ? disabledAi : disabledArtificial
      } else {
        this.exerciseModalTxt = this.isManual ? aiClassing : handleClick
      }
    },
  },
  created() {
    // 初始化钩子
  },
  beforeUnmount() {
    // 移除权限变化监听器
    if (this.permissionChangeCallback) {
      mqttServer.removePermissionListener(this.permissionChangeCallback)
    }
  },
  mounted() {
    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)

    setTimeout(() => {
      const doms = [...document.getElementsByClassName("signItem")]
      doms.forEach((dom, index) => {
        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            const transform = mutation.target.style.transform
            const matrix = transform ? new DOMMatrix(transform) : null
            const currentTransform = matrix?.m41 || 0

            if (currentTransform === CONSTANTS.SLIDING_TRANSFORM && this.moveTransform === 0) {
              this.moveTransform = currentTransform
              this.touchMove(transform, index)
              return
            }

            if (transform === "" && this.moveTransform === CONSTANTS.SLIDING_TRANSFORM) {
              this.moveTransform = 0
              this.touchMove("true", index)
              return
            }
          })
        })
        const config = { attributes: true, attributeFilter: ["style"] }
        observer.observe(dom, config)
      })
    }, CONSTANTS.OBSERVER_DELAY)

    this.userinfo = this.store.getUser()
    this.store.setAfterTestFlag("AFTER_TEST")
    this.getAudioType()

    if (this.dataList.length == 0) {
      this.queryVocabulary(this.currentStep)
    } else {
      setTimeout(() => {
        sessionStorage.setItem("pageFlag", "true")
      })
    }
    this.canSliding = mqttServer.getCanSend()

    // 监听权限变化
    this.permissionChangeCallback = () => {
      this.canSliding = mqttServer.getCanSend()
    }
    mqttServer.addPermissionListener(this.permissionChangeCallback)
  },
  methods: {
    onConfirmCloseWrap() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onConfirmCloseSync",
          msgType: "function",
        })
        .then(async () => {
          this.onConfirmCloseSync()
        })
    },
    async onConfirmCloseSync() {
      const modal = await modalController.create({
        component: PageDialog,
        id: "PageDialog",
        backdropDismiss: false,

        componentProps: { message: "确认回退吗?", type: "hasCancel" },
        cssClass: "center_modal_controller_class3",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if ("NEXT" === data) {
        modalController.dismiss()
        pagesQueue.queuePageChange("Nine")
      }
    },
    // 处理消息
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== "function") {
        throw new Error(`Method ${msg.fn} is not a function`)
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params)
        } else {
          await this[msg.fn](msg.params)
        }
        return true
      } catch (error) {
        console.error("Error executing method:", error)
        throw error // 或者根据需要处理错误
      }
    },
    touchMove(transform, index) {
      if (this.moveTimer) {
        clearTimeout(this.moveTimer)
      }
      this.moveTimer = setTimeout(() => {
        mqttServer.pushMsg(this.instructData, {
          params: [transform, index],
          fn: "handleTouchMove",
          msgType: "function",
          udp: true,
        })
      }, CONSTANTS.TOUCH_MOVE_DELAY)
    },

    handleStyle(e, event) {
      this.styleFlag = e
      this.currentEvent = event
    },

    async listenModalDismiss() {
      const { data } = await this.cutBoxModal.onDidDismiss()
      if ("NEXT" === data) {
        // 处理NEXT逻辑
      } else {
        this.cancelModel()
      }
    },

    handleTouchMove(transform, index) {
      this.moveTransform = transform === "true" ? 0 : new DOMMatrix(transform).m41
      this.$nextTick(() => {
        const itemStyleElements = document.getElementsByClassName("itemStyle")
        if (itemStyleElements[this.currentEvent]?.close) {
          itemStyleElements[this.currentEvent].close()
        }
        this.currentEvent = index

        const dom = document.getElementsByClassName("itemControl")[index]
        const optionsDom = document.getElementsByClassName("itemStyle")[index]
        const optionsList = document.getElementsByClassName("optionsList")[index]

        if (transform === "true") {
          dom.style.transform = "translate3d(0,0,0)"
          optionsDom.classList.remove("item-sliding-active-slide")
          optionsList.style.visibility = "hidden"
          return
        }

        optionsDom.classList.add("item-sliding-active-slide")
        optionsList.style.visibility = "visible"
        dom.style.transform = transform
      })
    },
    debouncePlayAudioWrap(index, item) {
      if (this.autoAudio?.loading) {
        return
      }
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [index, { ...item }, speedRate.value],
            fn: "onAutoSpeech",
            msgType: "function",
          })
          .then(async () => {
            await this.onAutoSpeech(index, item)
          })
          .catch((error) => {
            console.error("MQTT push error:", error)
          })
      } catch (error) {
        console.error("debouncePlayAudioWrap error:", error)
      }
    },
    playUniversalFormulaAudioWrap(word, paraphrase, speedRate, idx) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [word, paraphrase, speedRate, idx],
          fn: "playUniversalFormulaAudio",
          msgType: "function",
        })
        .then(async () => {
          this.playUniversalFormulaAudio(word, paraphrase, speedRate, idx)
          // this.autoShowClickGifSync(idx)
        })
    },

    playUniversalFormulaAudio,
    getBrandImageUrl,
    onDrag() {
      this.slidingItemClicked = true
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.slidingItemClicked = false
      }, CONSTANTS.SLIDING_CLICK_DELAY)
    },

    async openErrorSubmitDialogSync(item) {
      const modal = await modalController.create({
        component: ErrorSubmitDialog,
        componentProps: { wordObj: item },
        backdropDismiss: false,
        cssClass: "common_center_modal_container_transparent1",
      })
      await modal.present()
    },

    async openErrorSubmitDialog(item, index, event) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [item, event, index],
          fn: "openErrorSubmitDialogSync",
          msgType: "function",
        })
        .then(async () => {
          this.openErrorSubmitDialogSync(item)
        })
    },

    async changeExerciseModalSync() {
      if (!this.hasModeSwitch) return
      const modal = await modalController.create({
        component: switchModeDialog,
        id: "switchModeDialog",
        componentProps: { hasModeSwitch: this.hasModeSwitch, isManual: this.isManual },
        cssClass: "switch_modal_transparent",
      })
      await modal.present()
      setTimeout(() => {
        modalController.dismiss("", "", "switchModeDialog")
      }, CONSTANTS.MODAL_DISMISS_DELAY)
      const { data } = await modal.onDidDismiss()
      if ("NEXT" !== data) {
        return
      }

      this.isManual = !this.isManual
      sessionStorage.setItem("isManual", this.isManual)
      this.onResetStatus()
      if (this.isManual) {
        this.exerciseModalTxt = aiClassing
      } else {
        this.exerciseModalTxt = handleClick
      }
      this.addToSequence()
    },

    async changeExerciseModal() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "changeExerciseModalSync",
          msgType: "function",
        })
        .then(async () => {
          this.changeExerciseModalSync()
        })
    },

    routerBack() {
      modalController.dismiss()
    },

    // 显示点击动画异步
    autoShowClickGifSync(idx) {
      const img = document.getElementById(`img_click_${idx}`)
      if (img) {
        img.style.display = "block"
        setTimeout(() => {
          img.style.display = "none"
        }, CONSTANTS.MODAL_DISMISS_DELAY)
      }
    },

    // 显示点击动画
    autoShowClickGif(idx) {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "autoShowClickGifSync",
          msgType: "function",
        })
        .then(async () => {
          this.autoShowClickGifSync(idx)
        })
    },

    // item.autoIndex         领读步骤，1,2,3,4,5
    // this.autoButtonIndex   当前领读按钮下标
    // item.autoStudyNewWord  是否是新单词

    //控制领读是否显示
    autoShowClickButton(index, item) {
      return (
        item.autoIndex && item.autoStudyNewWord && this.autoButtonIndex === index && !this.isManual
      )
    },

    //获取蓝光指引的单词下标
    getCurrentClueIndex() {
      return this.wordSequence[this.currentWordIndex]
    },

    //重置自动领读状态
    autoResetStatus() {
      this.autoButtonIndex = 0
    },

    //调接口，文字转语音
    autoProduceSound(url, param) {
      // http://47.254.121.216:6039/api/speechMsg 英文发音
      // http://47.254.121.216:6039/api/speechMsgForZh  中英文发音

      let voiceUrl = "http://47.254.121.216:6039/"

      myAjax.post(url, param).then((res) => {
        voiceUrl = voiceUrl + res.data.msg
        this.audio(voiceUrl)
      })
    },

    //设置当前单词的点击状态
    controlItemStatus(itemIndex) {
      // 条目单词和注释的是否显示控制
      for (let i = 0; i < this.dataList.length; i++) {
        // 找到当前单词
        if (itemIndex === i) {
          // 记录当前单词点击次数，循环下标，0：未点击，1：初次点击，2.再次点击，3：显示注释，4：全部隐藏

          // 当为人工带读时总流程次数为3，ai带读时总流程次数为4
          const statusNum = this.isManual ? CONSTANTS.MANUAL_STATUS_NUM : CONSTANTS.AI_STATUS_NUM
          // 如果点击状态小于最大值，则每点击一次，状态前进一次
          if (this.dataList[i].showParaphrase < statusNum) {
            this.dataList[i].showParaphrase++
          } else {
            // 如果状态达到最大值，则从头开始
            this.dataList[i].showParaphrase = 1
          }
        }

        //重置其它单词点击状态
        else {
          this.dataList[i].showParaphrase = 0
        }
      }
    },

    //重置所有单词状态
    onResetStatus() {
      for (let i = 0; i < this.dataList.length; i++) {
        this.dataList[i].showParaphrase = 0
        this.dataList[i].clicked = false
        this.dataList[i].checked = false
        this.dataList[i].autoIndex = 1
        this.dataList[i].autoStudyNewWord = true
      }

      this.isDownward = true //自动发音方向
      this.speakIndex = 0 //当前发音数组下标
      this.currentWordIndex = 1 //当前所学单词在整个练习流程中的数组下标
      this.autoButtonIndex = 0 //显示自动点击按钮,决定当前显示哪一个按钮
      this.firstClickSpeak = true //重置发音按钮状态，确保打乱后从第一个单词开始发音
    },

    //显示单词释义，自动带读专用
    onShowParaphraseAuto(itemIndex, item, playSW) {
      // 高亮显示当前点击的条目
      this.changeStyle(itemIndex)

      //根据播放参数，判断本次点击是否需要发音
      if (playSW) {
        this.playSoundTemp(item)
      }

      //用于点击小喇叭图标时进行控制
      this.speakIndex = itemIndex

      //设置当前单词的点击状态为：已点击
      this.dataList[itemIndex].clicked = true

      // 点击到蓝光指引的单词时，控制领读步骤
      if (
        itemIndex === this.wordSequence[this.currentWordIndex] &&
        this.currentWordIndex < this.wordSequence.length
      ) {
        //移动数组下标到下一个单词
        this.currentWordIndex++

        //获取当前领读流程下的单词在单词列表的下标
        const next = this.getCurrentClueIndex()
        //如果这个单词是没有学过的单词，记录单词在单词列表中的下标
        if (next && this.dataList[next].autoStudyNewWord) {
          this.autoButtonIndex = next
        }

        //---------------------------------------

        // 更新页面标题
        this.updatePageTitle()
      }

      // 控制当前单词和注释的显隐状态
      this.controlItemStatus(itemIndex)
    },

    //自动领读
    async onAutoSpeech(idx, item, speedRate) {
      try {
        // 确保使用单例实例并在加载中直接返回，避免并发播放
        if (!this.autoAudio) {
          this.autoAudio = getOssPlayInstance()
        }
        if (this.autoAudio?.loading) {
          return
        }
        if (this.userinfo.isAdmin) {
          sessionStorage.setItem("isManual", false)
          this.isManual = false
          const speedList = CONSTANTS.SPEED_LIST
          const index = speedList.indexOf(speedRate)
          const sp = index === 0 ? speedList[speedList.length - 1] : speedList[index - 1]
          speedSwitch.value.changeSpeedSync(sp)
          for (let i = 0; i < idx; i++) {
            this.dataList[i].clicked = true
            this.dataList[i].autoIndex = undefined
            this.dataList[i].autoStudyNewWord = false
          }
          this.autoButtonIndex = idx
        }
        // Vue 3中直接赋值即可，响应式系统会自动处理
        this.dataList[idx] = item
        const currentItem = this.dataList[idx]

        this.currentSpeakItem = currentItem
        this.currentSpeakIndex = idx
        //this.autoShowClickGif(idx);
        if (!currentItem.autoIndex) {
          return
        }
        this.hasModeSwitch = false
        // 重要：用于人工和自动相互影响
        if ([1, 2, 3, 5].includes(currentItem.autoIndex)) {
          // 1，2，3，5，
          this.onShowParaphraseAuto(idx, currentItem, false)
        }
        this.aiSpeak(currentItem)
      } catch (error) {
        console.error("onAutoSpeech error:", error)
      }
    },
    aiSpeak(item) {
      const param = {
        msgId: `${item.vocabularyId}_${item.autoIndex}`,
      }

      let mySpeed = CONSTANTS.DEFAULT_SPEED

      switch (item.autoIndex) {
        case 2:
          param.msg = `${item.word}#${item.word}#${item.word}`
          mySpeed = CONSTANTS.AUTO_SPEED
          break
        case 3:
          param.msg = `${item.word}#${item.paraphrase}`
          mySpeed = CONSTANTS.AUTO_SPEED
          break
        case 4:
          param.msg = `${item.word}#${item.word}#${item.paraphrase}`
          mySpeed = CONSTANTS.AUTO_SPEED
          break
        default:
          param.msg = item.word
      }

      // 调用发音接口
      const trueSpeed = Math.min(mySpeed * speedRate.value, CONSTANTS.MAX_SPEED)
      const audioTypeRes = localStorage.getItem("audioType") ?? CONSTANTS.DEFAULT_AUDIO_TYPE

      // 使用单例模式
      this.autoAudio = getOssPlayInstance().init({
        msg: param.msg,
        rate: speedRate.value,
        speed: trueSpeed,
        audioPath: audioTypeRes,
      })
      // 标记本次为自动领读触发，进度完成后才推进 autoIndex
      this.isAutoSpeechPlaying = true
      this.autoAudio.setProgressCallback((val) => (this.progress = val))
      this.autoAudio.play()
    },
    //________________________________________________________________________

    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 2000)
      this.queryVocabulary(this.currentStep, RefreshAnimationEvent)
    },

    // 剪纸盒
    async openCutBoxSync() {
      // 重置自动领读状态
      this.autoResetStatus()
      pagesQueue.queuePagePush({
        page: "CutBox",
        params: { studentId: this.studentId, step: this.currentStep },
      })
      if (this.autoAudio) {
        this.autoAudio.reset()
        this.autoAudio = null
      }
      sessionStorage.setItem("pageFlag", "false")
      this.hasModeSwitch = true
    },

    //剪纸盒
    async openCutBox() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "openCutBoxSync",
          params: [this.currentStep],
          msgType: "function",
        })
        .then(async () => {
          this.openCutBoxSync()
        })
    },

    // 打乱
    async doRandomSync() {
      const modal = await modalController.create({
        component: PageDialog,
        id: "PageDialog",
        backdropDismiss: false,
        componentProps: {
          message: "打乱后将重新开始练习，确定要打乱吗?",
          type: "hasCancel",
        },
        cssClass: "center_modal_controller_class3",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      if ("NEXT" === data) {
        this.addToSequence()
        this.onResetStatus()
        if (this.userinfo.userType == "2") {
          this.randomList()
        }
      }
    },

    randomList() {
      this.dataList.sort(() => (Math.random() > 0.5 ? -1 : 1))
      mqttServer.pushMsg(this.instructData, {
        params: [this.dataList],
        fn: "randomListSync",
        msgType: "function",
      })
    },

    randomListSync(res) {
      this.dataList = res
    },

    //打乱
    async doRandom() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [this.dataList],
          fn: "doRandomSync",
          msgType: "function",
        })
        .then(() => {
          this.doRandomSync()
        })
    },

    //点击播放异步
    onSpeakSync() {
      const arr = document.querySelectorAll(".signItem")
      if (!this.firstClickSpeak) {
        if (this.isDownward) {
          if (this.speakIndex < this.dataList.length - 1) {
            this.speakIndex++
          } else {
            this.speakIndex--
            this.isDownward = false
          }
        } else {
          if (this.speakIndex > 0) {
            this.speakIndex--
          } else {
            this.speakIndex++
            this.isDownward = true
          }
        }
      }
      this.firstClickSpeak = false
      for (let i = 0; i < arr.length; i++) {
        if (this.speakIndex === i) {
          arr[i].click()
          this.dataList[i].clicked = true
        }
      }
    },

    //点击播放
    onSpeak() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onSpeakSync",
          msgType: "function",
        })
        .then(() => {
          this.onSpeakSync()
        })
    },

    // changeStyle(index) {
    //   for (let i = 0; i < this.dataList.length; i++) {
    //     if (index === i) {
    //       this.dataList[i]["checked"] = true
    //       this.currentItem = this.dataList[index]
    //     } else {
    //       this.dataList[i]["checked"] = false
    //     }
    //   }
    // },

    changeStyle(index) {
      this.dataList.forEach((item, i) => {
        item.checked = i === index
      })
      this.currentItem = this.dataList[index]
    },

    //点击单词播放发音
    onShowParaphraseSync(
      itemIndex,
      item,
      playSW,
      currentWordIndex,
      isDownward,
      autoButtonIndex,
      indexList,
      isManual
    ) {
      if (this.userinfo.isAdmin) {
        sessionStorage.setItem("isManual", isManual)
        this.isManual = isManual
        if (isManual) {
          this.onResetStatus()
          this.exerciseModalTxt = aiClassing
          this.addToSequence()
        } else {
          this.exerciseModalTxt = handleClick
        }
        this.isDownward = isDownward
        this.autoButtonIndex = autoButtonIndex
        this.currentWordIndex = currentWordIndex
        this.dataList[itemIndex] = item
        indexList.forEach((idx) => {
          if (this.dataList[idx]) {
            this.dataList[idx].autoStudyNewWord = false
          }
        })
      }
      //如果是自动且一次没有点击过的单词，则禁止点击
      if (!this.isManual && !this.dataList[itemIndex].clicked) {
        return
      }
      if (!this.isManual && this.currentItem.autoIndex !== undefined) {
        return
      }

      this.hasModeSwitch = false
      this.changeStyle(itemIndex)

      if (playSW) {
        if (!this.isManual) {
          this.dataList.splice(itemIndex, 1, {
            ...this.dataList[itemIndex],
            playbackRate: speedRate.value,
          })
        } else {
          this.dataList[itemIndex].playbackRate = 1
        }
        if (!this.slidingItemClicked) {
          item.playbackRate = speedRate.value
          this.playSoundTemp(item)
        }
      }

      this.speakIndex = itemIndex
      this.dataList[itemIndex].clicked = true
      if (itemIndex === this.wordSequence[this.currentWordIndex]) {
        if (this.currentWordIndex < this.wordSequence.length) {
          this.currentWordIndex++

          // 自动领读
          //---------------------------------------
          const next = this.getCurrentClueIndex()
          if (next && this.dataList[next].autoStudyNewWord) {
            this.autoButtonIndex = next
          }
          //---------------------------------------

          this.updatePageTitle()
        }
      }

      // 控制当前单词和注释的显隐状态
      this.controlItemStatus(itemIndex)
    },

    onShowParaphrase(itemIndex, item, playSW) {
      if (this.autoAudio?.loading) {
        return
      }
      // 找出dataList数组中所有autoStudyNewWord的值是false的单词的索引
      const indexList = this.dataList
        .map((item, index) => (!item.autoStudyNewWord ? index : null))
        .filter((idx) => idx !== null && idx !== undefined)
      mqttServer
        .pushMsg(this.instructData, {
          params: [
            itemIndex,
            item,
            playSW,
            this.currentWordIndex,
            this.isDownward,
            this.autoButtonIndex,
            indexList,
            this.isManual,
          ],
          fn: "onShowParaphraseSync",
          msgType: "function",
        })
        .then(() => {
          this.onShowParaphraseSync(itemIndex, item, playSW)
        })
    },

    //标记为难词
    markDifficultSync(vocabularyId) {
      this.ajax
        .post("/vocabulary/markDifficultInForget", {
          studentId: this.studentId,
          vocabularyId: vocabularyId,
          difficult: true,
        })
        .then(() => {
          this.alert("操作成功")
        })
    },

    //标记为难词
    markDifficult(vocabularyId, index, event) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [vocabularyId, event, index],
          fn: "markDifficultSync",
          msgType: "function",
        })
        .then(() => {
          this.markDifficultSync(vocabularyId)
        })
    },
    // 打开有道翻译
    async onParaphraseSync(word) {
      const modal = await modalController.create({
        component: Paraphrase,
        componentProps: { word },
        cssClass: "modal_controller_class",
      })
      await modal.present()
    },

    // 打开有道翻译
    async onParaphrase(word, index, event) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [word, index, event],
          fn: "onParaphraseSync",
          msgType: "function",
        })
        .then(() => {
          this.onParaphraseSync(word)
        })
    },

    async routerToAiVocabularySync(word) {
      const modal = await modalController.create({
        component: AIGenerate,
        componentProps: { word: word },
      })
      await modal.present()
    },
    async routerToAiVocabulary(word) {
      mqttServer
        .pushMsg(this.instructData, {
          params: word,
          fn: "routerToAiVocabularySync",
          msgType: "function",
        })
        .then(() => {
          this.routerToAiVocabularySync(word)
        })
    },
    queryVocabularySync(res, step, ev) {
      const page = res.data.page
      const list = page.list
      this.isDownward = true //自动发音方向
      this.speakIndex = 0 //当前发音数组下标
      this.pageTitle = "单词识记"
      if (list) {
        this.totalPage = page.pages
        this.dataList = list.map((item) => ({
          ...item,
          status: 1,
          clicked: false,
          showParaphrase: 0,
          autoIndex: 1, // 自动发音步骤，1,2,3,4,5
          autoStudyNewWord: true, // 是否学新单词
          playbackRate: 1,
        }))
        this.addToSequence()
      }
      setTimeout(() => {
        sessionStorage.setItem("pageFlag", "true")
      }, CONSTANTS.PAGE_FLAG_DELAY)

      if (ev) {
        ev.target.complete()
      }
    },

    queryVocabulary(step, ev) {
      this.ajax
        .post("/vocabulary/queryCurrentWords", {
          studentId: this.studentId,
          pageNum: step,
        })
        .then((res) => {
          this.queryVocabularySync(res, step, ev)
        })
    },
    // 生成单词序列的辅助方法
    addSequenceGroup(group) {
      group.forEach((index) => this.wordSequence.push(index))
    },

    // 自动下一步 - 2个单词
    addToSequence2() {
      this.addSequenceGroup([0, 1, 0, 1]) // 第一组
    },

    // 自动下一步 - 3个单词
    addToSequence3() {
      this.addSequenceGroup([0, 1, 0, 1, 2]) // 第一组
      this.addSequenceGroup([1, 0, 1, 2]) // 第二组
    },

    // 自动下一步 - 4个单词
    addToSequence4() {
      this.addSequenceGroup([0, 1, 0, 1, 2]) // 第一组
      this.addSequenceGroup([1, 0, 1, 2, 3]) // 第二组
      this.addSequenceGroup([2, 1, 0, 1, 2]) // 第三组
      this.addSequenceGroup([3]) // 第四组
    },

    // 自动下一步 - 5个单词
    addToSequence5() {
      this.addSequenceGroup([0, 1, 0, 1, 2]) // 第一组
      this.addSequenceGroup([1, 0, 1, 2, 3]) // 第二组
      this.addSequenceGroup([2, 1, 0, 1, 2]) // 第三组
      this.addSequenceGroup([3, 4, 3, 2, 3]) // 第四组
      this.addSequenceGroup([4, 1, 0, 1, 0]) // 第五组
      this.addSequenceGroup([1, 2, 3, 4, 3]) // 第六组
      this.addSequenceGroup([2, 1, 0]) // 第七组
    },

    addToSequence() {
      this.currentWordIndex = 1
      this.wordSequence = []
      const sequenceMap = {
        2: () => this.addToSequence2(),
        3: () => this.addToSequence3(),
        4: () => this.addToSequence4(),
        5: () => this.addToSequence5(),
      }
      const handler = sequenceMap[this.dataList.length]
      if (handler) {
        handler()
      }
    },

    // 更新页面标题
    updatePageTitle() {
      if (this.currentWordIndex === CONSTANTS.REVIEW_STEP) {
        this.pageTitle = "本组复习"
      } else if (this.currentWordIndex === CONSTANTS.LISTEN_STEP) {
        this.pageTitle = "听音识词"
      }
    },
    async getAudioType() {
      try {
        const audioTypeRes = await myAjax.get("/AiSwitch/getPronounceType")
        const audioType =
          audioTypeRes.data.code === 200
            ? (audioTypeRes.data.data ?? CONSTANTS.DEFAULT_AUDIO_TYPE)
            : CONSTANTS.DEFAULT_AUDIO_TYPE
        localStorage.setItem("audioType", audioType)
      } catch (error) {
        console.error("获取音频类型失败:", error)
        localStorage.setItem("audioType", CONSTANTS.DEFAULT_AUDIO_TYPE)
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.display-none {
  display: none !important;
}

.sign {
  width: 100%;
  height: 100%;
  position: relative;
  user-select: none;
  -webkit-user-select: none;

  &_page {
    width: 100%;
    height: 92%;
    padding: 0.8rem;
    overflow: scroll;
    background-color: #ffffff;

    .word-list {
      .w100 {
        flex: 1;
        width: 100%;
      }

      &_item {
        width: 100%;
        //padding: 4vw;
        background-color: var(--page-bg-color);
        border-radius: 2vw;
        margin-bottom: 5vw;
        border: 1px solid transparent;
        position: relative;

        .ion-item {
          width: 100%;
          padding: 4vw;
          background-color: var(--page-bg-color);
          --border-color: transparent;
          --background: transparent;
          --padding-start: 0;
          --inner-padding-end: 0;
          position: relative;
          overflow: unset;
          --overflow: unset;

          &::part(native) {
            width: 100%;
          }

          .word-content {
            flex: 1;
            width: calc(100% - 18vw);
            flex-wrap: wrap;
          }

          .auto-button {
            width: 12vw;
            height: 7vw;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: 3vw;
          }
        }

        .auto-index {
          width: 7vw;
          height: 7vw;
          background: #2bca9c;
          color: #fff;
          border-radius: 50%;
          position: relative;
          transform: scale(1.3);

          &::before {
            content: attr(data-progress);
            position: absolute;
            inset: 0.6vw;
            background: #2bca9c;
            width: 5.8vw;
            height: 5.8vw;
            font-size: 1rem;
            line-height: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
          }
        }

        .auto-index__disabled {
          background: conic-gradient(
            #2bca9c var(--progress),
            transparent 0.1%,
            #2bca9c33 var(--last)
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-1 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #b1b5b8 20%,
            #b1b5b8 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #b1b5b8 40%,
            #b1b5b8 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #b1b5b8 60%,
            #b1b5b8 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #b1b5b8 80%,
            #b1b5b8 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-2 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #2bca9c 20%,
            #2bca9c 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #b1b5b8 40%,
            #b1b5b8 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #b1b5b8 60%,
            #b1b5b8 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #b1b5b8 80%,
            #b1b5b8 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-3 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #2bca9c 20%,
            #2bca9c 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #2bca9c 40%,
            #2bca9c 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #b1b5b8 60%,
            #b1b5b8 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #b1b5b8 80%,
            #b1b5b8 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-4 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #2bca9c 20%,
            #2bca9c 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #2bca9c 40%,
            #2bca9c 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #2bca9c 60%,
            #2bca9c 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #b1b5b8 80%,
            #b1b5b8 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .auto-index-5 {
          background: conic-gradient(
            #2bca9c 0%,
            #2bca9c 16%,
            #2bca9c33 16%,
            #2bca9c33 20%,
            #2bca9c 20%,
            #2bca9c 36%,
            #2bca9c33 36%,
            #2bca9c33 40%,
            #2bca9c 40%,
            #2bca9c 56%,
            #2bca9c33 56%,
            #2bca9c33 60%,
            #2bca9c 60%,
            #2bca9c 76%,
            #2bca9c33 76%,
            #2bca9c33 80%,
            #2bca9c 80%,
            #2bca9c 96%,
            #2bca9c33 96%,
            #2bca9c33 100%
          );

          &::before {
            background: #d5f4eb;
            color: #9ae6d0;
          }
        }

        .audio-button {
          width: 7.5vw;
        }

        .sign-option {
          background: var(--page-bg-color);

          &::part(native) {
            padding: 0;
            width: 58px;
            height: 100%;
          }

          img {
            height: 73px;
            width: 100%;
            object-fit: cover;
          }
        }

        .left-line {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
          width: 2px;
          height: 100%;
          border-radius: 0.5vw;
          background-color: #c6feff;
          z-index: 999;
        }

        .word-style {
          display: inline-block;
          font-size: var(--font-18);
          word-break: break-all;
          max-width: 100%;
        }
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }
  }

  .item-checked {
    border: 1px solid var(--theme-color);
    background-color: var(--font-white);
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 8%;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);

    &-content {
      height: 60%;
      padding: 1.5vh 3vw 0;

      ion-button::part(native) {
        --padding-top: 4vw;
        --padding-bottom: 4vw;
        --padding-start: 4vw;
        --padding-end: 4vw;
      }

      .button {
        height: 5vw;
      }
    }
  }
}

.button-class {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button-icon {
  width: 3.5rem;
  height: 3.5rem;
  cursor: pointer;
  margin-top: 0.6rem;
}

.mode-switch {
  width: 2rem;
  height: 2rem;
  margin-left: 1rem;
  cursor: pointer;
}

.button-disabled {
  filter: grayscale(100%);
  pointer-events: none;
}
</style>
